<template>
  <section id="dashboard" :class="{ 'has-demo-banner': isDemo }">
    <subscription-flag v-if="isDemo" />
    <modal-onboarding v-if="showOnboarding && false" :show="true" menuName="Menu" />

    <transition name="fade">
      <button v-if="menuOpen" class="sidebar-backdrop mobile" type="button" aria-label="Fechar menu" @click="closeMenu"></button>
    </transition>

    <aside id="main-navigation" class="sidebar" :class="{ expand: menuOpen, isdemo: isDemo }" aria-label="Navegação principal">
      <div class="logo">
        <img src="@/assets/img/icon.png" width="42" alt="" />
        <div class="brand-copy"><strong>123MAIL</strong><small>Marketing & CRM</small></div>
        <button class="mobile sidebar-close" type="button" aria-label="Fechar menu" @click="closeMenu"><i class="fas fa-times"></i></button>
      </div>

      <nav class="menu">
        <span class="menu-label">Visão geral</span>
        <ul>
          <li v-if="checkResource('report')">
            <router-link :to="{ name: 'Report' }" :class="{ current: $route.name === 'Report' }" @click.native="closeMenu">
              <i class="fas fa-chart-pie"></i><span>Dashboard</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'Pipeline' }" :class="{ current: routeIncludes('Pipeline') }" @click.native="closeMenu">
              <i class="fas fa-stream"></i><span>CRM</span>
            </router-link>
          </li>
          <li v-if="checkResource('contact')">
            <router-link :to="{ name: 'Contact' }" :class="{ current: routeIncludes('Contact') }" @click.native="closeMenu">
              <i class="fas fa-address-book"></i><span>Contatos</span>
            </router-link>
          </li>
          <li v-if="checkResource('campaign')">
            <router-link :to="{ name: 'Campaign' }" :class="{ current: routeIncludes('Campaign') }" @click.native="closeMenu">
              <i class="fas fa-paper-plane"></i><span>Campanhas</span>
            </router-link>
          </li>
          <li v-if="checkResource('automation')">
            <router-link :to="{ name: 'Automation' }" :class="{ current: routeIncludes('Automation') }" @click.native="closeMenu">
              <i class="fas fa-robot"></i><span>Automações</span>
            </router-link>
          </li>
        </ul>

        <template v-if="checkResource('config')">
          <span class="menu-label settings-label">Configurações</span>
          <ul>
            <li>
              <router-link :to="{ name: 'ConfigIntegration' }" :class="{ current: routeIncludes('ConfigIntegration') }" @click.native="closeMenu">
                <i class="fas fa-plug"></i><span>Integrações</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'ConfigUser' }" :class="{ current: $route.name === 'ConfigUser' }" @click.native="closeMenu">
                <i class="fas fa-users"></i><span>Usuários</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'ConfigAccount' }" :class="{ current: $route.name === 'ConfigAccount' }" @click.native="closeMenu">
                <i class="fas fa-sliders-h"></i><span>Conta e plano</span>
              </router-link>
            </li>
          </ul>
        </template>
      </nav>

      <div class="sidebar-footer">
        <div class="sidebar-account">
          <div class="account-avatar">{{ accountInitial }}</div>
          <div class="sidebar-account-copy"><strong>{{ account.name || 'Minha conta' }}</strong><small v-if="account.id">Conta #{{ account.id }}</small></div>
        </div>
        <div class="sidebar-actions">
          <router-link v-if="hasMultipleAccounts" :to="{ name: 'Account' }" title="Trocar conta" aria-label="Trocar conta" @click.native="closeMenu"><i class="fas fa-exchange-alt"></i></router-link>
          <button type="button" title="Sair" aria-label="Sair da plataforma" @click="logout"><i class="fas fa-sign-out-alt"></i></button>
        </div>
      </div>
    </aside>

    <main class="main-content">
      <header class="top-bar">
        <div class="top-bar-main">
          <button class="mobile menu-toggle" type="button" aria-controls="main-navigation" :aria-expanded="menuOpen ? 'true' : 'false'" aria-label="Abrir menu" @click="openMenu"><i class="fas fa-bars"></i></button>
          <div class="page-heading">
            <breadcrumb />
            <h1>{{ pageTitle }}</h1>
          </div>
        </div>

        <div class="top-actions">
          <router-link v-if="hasMultipleAccounts" :to="{ name: 'Account' }" class="account-switcher" title="Trocar conta">
            <div class="account-avatar">{{ accountInitial }}</div>
            <div class="account-summary"><small>Conta atual</small><strong>{{ account.name || 'Minha conta' }}</strong></div>
            <i class="fas fa-chevron-down"></i>
          </router-link>
          <div v-else class="account-switcher static-account">
            <div class="account-avatar">{{ accountInitial }}</div>
            <div class="account-summary"><small>Conta atual</small><strong>{{ account.name || 'Minha conta' }}</strong></div>
          </div>
          <button class="logout-button" type="button" title="Sair" aria-label="Sair da plataforma" @click="logout"><i class="fas fa-sign-out-alt"></i></button>
        </div>
      </header>

      <section class="content-container">
        <div v-if="canShowContent" :class="{ 'max-1200': $route.name !== 'Pipeline' }" class="page-content"><slot /></div>
        <div v-else-if="isAccountBlocked" class="max-1200 page-content"><blocked /></div>
        <div v-else-if="isAccountLimitExceeded" class="max-1200 page-content"><limit-exceeded /></div>
      </section>
    </main>
  </section>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import SubscriptionFlag from "@/components/subscriptionFlag/SubscriptionFlag";
import Blocked from "@/components/blocked/Blocked";
import LimitExceeded from "@/components/blocked/LimitExceeded";
import ModalOnboarding from "@/components/modal/ModalOnboarding.vue";
import { mapState } from "vuex";
import { Account } from "@/services/account";
import { getUser, AccountsList } from "@/services/user";

export default {
  name: "Dashboard",
  components: { Breadcrumb, SubscriptionFlag, Blocked, LimitExceeded, ModalOnboarding },
  data() {
    return { menuOpen: false, accounts: [] };
  },
  computed: {
    ...mapState({ user: (state) => state.user, account: (state) => state.account }),
    showOnboarding() {
      if (!this.user || this.user.complet_onboarding === "") return false;
      return !this.user.complet_onboarding;
    },
    hasMultipleAccounts() {
      return this.accounts && this.accounts.length > 1;
    },
    isDemo() {
      const demoAccId = process && process.env && process.env.VUE_APP_DEMO_ACCOUNT;
      return demoAccId == this.account.id;
    },
    isAccountBlocked() {
      return this.account && this.account.status === "BLOCKED";
    },
    isAccountLimitExceeded() {
      return this.account && this.account.status === "LIMIT_EXCEEDED";
    },
    subscriptionRoute() {
      return this.$route.name === "ConfigAccount";
    },
    canShowContent() {
      return (!this.isAccountBlocked && !this.isAccountLimitExceeded) || ((this.isAccountBlocked || this.isAccountLimitExceeded) && this.subscriptionRoute);
    },
    accountInitial() {
      return (this.account && this.account.name ? this.account.name.charAt(0) : "1").toUpperCase();
    },
    pageTitle() {
      const breadcrumb = this.$route.meta && this.$route.meta.breadcrumb;
      return breadcrumb && breadcrumb.length ? breadcrumb[breadcrumb.length - 1].name : "123Mail";
    },
  },
  watch: {
    "$route.name"() { this.closeMenu(); },
  },
  mounted() {
    if (!this.account.status) this.getAccountInfo();
    if (!this.user.id) this.getUserInfo();
    this.getAccountsList();
    window.addEventListener("keydown", this.handleKeydown);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeydown);
    document.body.style.overflow = "";
  },
  methods: {
    openMenu() {
      this.menuOpen = true;
      document.body.style.overflow = "hidden";
    },
    closeMenu() {
      this.menuOpen = false;
      document.body.style.overflow = "";
    },
    handleKeydown(event) {
      if (event.key === "Escape") this.closeMenu();
    },
    routeIncludes(name) {
      return Boolean(this.$route.name && this.$route.name.includes(name));
    },
    logout() {
      this.closeMenu();
      this.$store.dispatch("logout");
      this.$router.push({ name: "Login" });
    },
    checkResource(name) {
      return Boolean(this.account && this.account.resources && this.account.resources.includes(name));
    },
    getAccountInfo() {
      Account().then((result) => this.$store.dispatch("setAccount", result));
    },
    getUserInfo() {
      getUser().then((result) => this.$store.dispatch("auth", result));
    },
    getAccountsList() {
      AccountsList().then((response) => { this.accounts = response; });
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar { display: flex; flex-direction: column; }
.menu { flex: 1; overflow-y: auto; overflow-x: hidden; scrollbar-width: thin; scrollbar-color: rgba(255,255,255,.18) transparent; }
#dashboard .sidebar .menu > .menu-label { min-height: auto; margin: 22px 12px 7px; padding: 0; display: block; color: rgba(255,255,255,.34); font-size: 1rem; font-weight: 700; letter-spacing: .11em; text-transform: uppercase; }
.settings-label { margin-top: 28px; }
.menu ul { margin: 0; padding: 0; list-style: none; }
#dashboard .sidebar .menu li { min-height: auto; margin: 4px 0 0; padding: 0; display: block; background: none; border-radius: 0; }
#dashboard .sidebar .menu li:hover { background: none; transform: none; }
.menu a { min-height: 44px; padding: 11px 12px; display: flex; align-items: center; border-radius: 10px; color: rgba(255,255,255,.68); transition: color .18s ease, background .18s ease, transform .18s ease; }
.menu a:hover { color: #fff; background: rgba(255,255,255,.07); transform: translateX(2px); }
.menu a.current { color: #fff; background: linear-gradient(135deg, #8b5cf6, #6d28d9); box-shadow: 0 8px 20px rgba(91,33,182,.28); }
#dashboard .sidebar .menu a i { width: 22px; margin: 0 12px 0 0; text-align: center; font-size: 1.5rem; opacity: .85; }

.sidebar-footer { margin-top: 20px; padding: 16px 6px 0; display: flex; align-items: center; border-top: 1px solid rgba(255,255,255,.08); }
.sidebar-account { min-width: 0; flex: 1; display: flex; align-items: center; }
.sidebar-account-copy { min-width: 0; display: flex; flex-direction: column; }
.sidebar-account-copy strong { overflow: hidden; color: #fff; font-size: 1.2rem; text-overflow: ellipsis; white-space: nowrap; }
.sidebar-account-copy small { margin-top: 3px; color: rgba(255,255,255,.42); font-size: 1rem; }
.sidebar-actions { margin-left: 8px; display: flex; }
.sidebar-actions a, .sidebar-actions button { width: 34px; height: 34px; display: flex; align-items: center; justify-content: center; border: 0; border-radius: 8px; color: rgba(255,255,255,.58); background: transparent; cursor: pointer; }
.sidebar-actions a:hover, .sidebar-actions button:hover { color: #fff; background: rgba(255,255,255,.08); }

.top-bar { display: flex; align-items: center; justify-content: space-between; }
.top-bar-main { min-width: 0; display: flex; align-items: center; }
.page-heading { min-width: 0; }
.page-heading h1 { margin-top: 5px; color: #171923; font-size: 2rem; font-weight: 700; letter-spacing: -.02em; }
.top-actions { margin-left: 24px; display: flex; align-items: center; }
.account-switcher { min-width: 0; padding: 6px 9px; display: flex; align-items: center; border: 1px solid transparent; border-radius: 11px; color: #171923; transition: background .18s ease, border-color .18s ease; }
a.account-switcher:hover { border-color: #e5dff0; background: #faf8ff; }
.account-switcher > i { margin: 0 5px 0 12px; color: #98a2b3; font-size: 1rem; }
.account-summary { max-width: 220px; display: flex; flex-direction: column; }
.account-summary small { color: #98a2b3; font-size: 1rem; }
.account-summary strong { margin-top: 2px; overflow: hidden; font-size: 1.2rem; text-overflow: ellipsis; white-space: nowrap; }
.account-avatar { flex: 0 0 auto; }
.logout-button { width: 40px; height: 40px; margin-left: 8px; border: 0; border-radius: 10px; color: #667085; background: transparent; cursor: pointer; transition: color .18s ease, background .18s ease; }
.logout-button:hover { color: #b42318; background: #fef3f2; }
.content-container { display: flex; justify-content: center; width: 100%; }
.page-content { width: 100%; }
.fade-enter-active, .fade-leave-active { transition: opacity .2s ease; }
.fade-enter, .fade-leave-to { opacity: 0; }

@media screen and (max-width: 1024px) {
  .menu-toggle { margin-right: 10px; }
  .page-heading h1 { margin: 0; font-size: 1.7rem; }
  .account-summary { display: none; }
  .account-switcher { padding: 4px; }
  .account-switcher > i { margin: 0 4px 0 7px; }
}
@media screen and (max-width: 560px) {
  .top-actions { margin-left: 8px; }
  .static-account { display: none; }
  .logout-button { margin-left: 0; }
  .page-heading h1 { max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
}
</style>
